import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useEffect } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import AttributesEditor from "./AttributesEditor";
import { CustomViewAttributesStoreContext } from "./CustomViewAttributesStore";

const AttributesTab: FunctionComponent = observer(() => {
	const { attributesStore } = useCustomViewDialogStore();

	useEffect(() => {
		return () => {
			attributesStore.disposeOfContainerReactions();
		};
	}, []);

	return (
		<CustomViewAttributesStoreContext.Provider value={attributesStore}>
			<AttributesEditor />
		</CustomViewAttributesStoreContext.Provider>
	);
});

export default AttributesTab;
